<script setup lang="ts"></script>

<template>
  <header
    class="fixed top-0 w-screen min-h-20 flex flex-col justify-between z-30 bg-secondary-900">
    <HeadlessPopoverGroup
      class="relative w-full flex items-center justify-between gap-4 py-4 px-3 pr-7 overscroll-none">
      <div class="absolute top-0 left-8">
        <!--<DevOnly>
          <NuxtLinkLocale
            to="/test"
            class="text-neutral-200 hover:text-primary-500 transition-colors">
            Go to /test
          </NuxtLinkLocale>
        </DevOnly>-->
      </div>
      <HeaderNavGames />

      <!--<NuxtLinkLocale
        to="/"
        class="absolute left-1/2 -translate-x-1/2"
        data-test="link-marketplace-logo"
        aria-label="Link to Home Page">
        <BaseIconMarketplaceLogo />
      </NuxtLinkLocale>-->

      <HeaderAccount />
    </HeadlessPopoverGroup>
    <HeaderNavPages />
  </header>
</template>
